import {
    pledgeAmountToPayRowsInvalid,
    syncPledgeAmountToPayInputStyles,
} from './pledge-pay-amount';
import { syncRecurringInstallmentFields } from './pledge-pay-recurring';
import {
    blockPledgeScheduleStartDateIfNotFuture,
    pledgeScheduleStartNotFutureMessage,
} from '../shared/pledge-schedule-start-date.js';
import { getPaymentMode } from './pledge-pay-utils';

function showPledgeBillPayErrors($payRoot, lines) {
    const items = (lines || []).filter(Boolean);
    if (!items.length) {
        return;
    }
    const $cardErr = $payRoot.find('#mgr_pledge_bill_cc_ajax_err');
    const $cardUl = $payRoot.find('#mgr_pledge_bill_cc_ajax_err_ul');
    if ($cardErr.length && $cardUl.length) {
        $cardUl.empty();
        items.forEach((line) => {
            $cardUl.append($('<li>').text(line));
        });
        $cardErr.show();
        return;
    }
    const $msg = $payRoot.find('#ajaxMsgMatanahAmt');
    const $ul = $payRoot.find('#ajaxMsgMatanahAmtUl');
    if ($msg.length && $ul.length) {
        $ul.html(items.map((line) => `<li><i class="fa-regular fa-circle-x"></i>&nbsp;${line}</li>`).join(''));
        $payRoot.find('#matanah_message').removeClass('alert-success').addClass('alert-danger');
        $msg.show();
        return;
    }
    showAlertMsg(items[0], 'danger');
}

function validatePledgeBillPaymentState($payRoot) {
    syncPledgeAmountToPayInputStyles($payRoot);
    if (pledgeAmountToPayRowsInvalid($payRoot)) {
        showPledgeBillPayErrors($payRoot, ['The amount is required. Please fix the amounts highlighted in red.']);
        return false;
    }

    if (!syncRecurringInstallmentFields($payRoot)) {
        showPledgeBillPayErrors($payRoot, ['Set frequency and duration (at least 2 payments) before continuing.']);
        return false;
    }

    if (getPaymentMode($payRoot) === 'recurring' && blockPledgeScheduleStartDateIfNotFuture($payRoot)) {
        showPledgeBillPayErrors($payRoot, [pledgeScheduleStartNotFutureMessage()]);
        return false;
    }

    return true;
}

export {
    showPledgeBillPayErrors,
    validatePledgeBillPaymentState,
};
